<template>
  <div class="app-container">
    <header class="auth-header">
      <router-link to="/">
        <img src="@/assets/logo.svg" alt="AVTOVIZIJA Logo" class="auth-logo"/>
      </router-link>
    </header>
    <main class="main">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
};
</script>

<style scoped>
.main {
  padding-top: 0; /* Odstranimo odmik od vrha, ker ni navigacije */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>